import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { setChartOption } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-options/chart-options.actions';
import { FundChartOptionValue } from 'ChartApp/ts/enums/fund-chart-common.enum';
export const performanceDisclosure = createReducer(false, on(setChartData, (state, { chartData }) => chartData.params.performanceDisclosure), on(setChartOption, (state, action) => action.chartOption.value === FundChartOptionValue.SHOW_PERFORMANCE_DISCLOSURE
    ? action.chartOption.selected
    : state));
